<div class="form-check">
  <input class="form-check-input" type="checkbox"
    autocomplete="off"
    [class.is-invalid]="showError"
    [indeterminate]="props.indeterminate && formControl.value === null"
    [formControl]="checkboxFormControl"
    [formlyAttributes]="field">
  <label class="form-check-label" [for]="id">
    {{ props.label }}
    @if (props.required && props.hideRequiredMarker !== true) {
      <span>*</span>
    }
  </label>
</div>
